/**
 * AP-773 — step factory for worksheet actions (§3.1 A5–A8).
 *
 * A worksheet step is a pair of worksheet snapshots. The "after" side is
 * captured lazily on the first undo: the commit's consequences (derived
 * recompute, AI soft-delete) land in React effects after the handler runs,
 * and by the time the reader undoes, the top step is by construction the last
 * thing that changed the worksheet (I3, linear).
 */
import {
  runApplyingHistory,
  type HistoryActionKind,
  type HistoryStep,
} from './historyStore';
import {
  applyWorksheetSnapshot,
  getWorksheetSnapshot,
  type WorksheetSnapshot,
} from './worksheetApplier';

export function createWorksheetStep(
  action: Extract<HistoryActionKind, 'A5' | 'A6' | 'A7' | 'A8'>,
  before: WorksheetSnapshot,
  /** R20 message label, e.g. "LVEDV value", "finding statement". */
  label: string
): HistoryStep {
  let after: WorksheetSnapshot | null = null;
  return {
    action,
    label,
    undo: () => {
      after ??= getWorksheetSnapshot();
      runApplyingHistory(() => applyWorksheetSnapshot(before));
    },
    redo: () => {
      const snapshot = after;
      if (snapshot) runApplyingHistory(() => applyWorksheetSnapshot(snapshot));
    },
  };
}
